import { Delete, Download, Edit } from '@mui/icons-material';
import { Box } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButtonLink } from '~/components/button';
import { TableAction } from '~/components/table';
import type { FontList__Font as Font } from '../../queries/list.generated';

interface UseColumnsOptions {
  onDelete: (font: Font) => void;
}

export const useColumns = ({ onDelete }: UseColumnsOptions) => {
  const { t } = useTranslation();

  return useMemo<GridColDef<Font>[]>(
    () => [
      {
        field: 'name',
        flex: 1,
        headerName: t('common.labels.name'),
        renderCell: ({ row }) => <Box sx={{ fontFamily: row.name }}>{row.name}</Box>,
      },
      {
        align: 'right',
        field: 'actions',
        flex: 1,
        getActions: ({ row }) => [
          <ActionButtonLink
            key={`edit-${row.id}`}
            title={t('common.buttons.edit')}
            Icon={Edit}
            to={`${row.id}`}
          />,
          <TableAction
            key={`download-${row.id}`}
            title={t('common.buttons.download')}
            Icon={Download}
            onClick={() => window.open(row.file.uri, '_blank')}
          />,
          <TableAction
            color="error"
            disabled={!row.canDelete.value}
            key={`delete-${row.id}`}
            title={
              row.canDelete.reasons?.fullMessages.join() || t('pages.fonts.actions.delete_font')
            }
            Icon={Delete}
            onClick={() => onDelete(row)}
          />,
        ],
        headerAlign: 'right',
        type: 'actions',
      },
    ],
    [onDelete, t],
  );
};
